var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('meta',{attrs:{"http-equiv":"refresh","content":"0; url=https://anvil.live/lipi"}})])}]

export { render, staticRenderFns }